import React, { useEffect, useState } from 'react'
import Header from '../Utilities/Header'
import Footer from '../Utilities/Footer'
import { Link } from 'react-router-dom'
import { fetchBlogs, formatBlogDate } from '../Utilities/api';
import BCategory from '../Utilities/BCategory';
import LatestPosts from '../Utilities/LatestPosts';
import { Helmet } from 'react-helmet'

const BLOGS_PER_PAGE = 20;

const Blog = () => {

  const [blogs, Setblogs] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    // 👇️ scroll to top on page load

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    fetchBlogs()
      .then(data => {
        Setblogs(data.filter(blog => blog.status === 'published'));
      })
      .catch(err => console.error('Failed to fetch blogs:', err));
  }, []);

  const pageCount = Math.ceil(blogs.length / BLOGS_PER_PAGE);
  const paginatedBlogs = blogs.slice((page - 1) * BLOGS_PER_PAGE, page * BLOGS_PER_PAGE);

  const goToPage = (nextPage) => {
    if (nextPage < 1 || nextPage > pageCount) return;
    setPage(nextPage);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <Header />
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://www.wisefinserv.com/blog" />
      </Helmet>
      <div className="blog">
        <div class="page-title">
          <h4>Blogs</h4>
        </div>
        <div className="blog-body">
          <div className="blog-body-content">
            {paginatedBlogs.map(blog => (
              <div className="blog-card" key={blog._id}>
                {/* <img src={blog.image?.url} alt={blog.title} /> */}
                <div className="blog-card-text">
                  <span>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" /></svg> */}
                    {formatBlogDate(blog)}
                  </span>

                  <Link to={"/blog/" + blog.slug}>{blog.title}</Link>
                  <div className="category">
                    <h6>Category:&nbsp;</h6>
                    {blog.categories.map((data) => (
                      <p key={data._id}>{data.title}</p>
                    ))}
                  </div>
                  <div className='body' dangerouslySetInnerHTML={{ __html: blog.shortDescription || blog.content }}></div>
                  <Link className='Read' to={"/blog/" + blog.slug}>Read More</Link>
                </div>
              </div>
            ))}
            <hr />

            {pageCount > 1 && (
              <div className="blog-pagination">
                <button
                  type="button"
                  disabled={page === 1}
                  onClick={() => goToPage(page - 1)}
                >
                  Prev
                </button>

                {Array.from({ length: pageCount }, (_, i) => i + 1).map(num => (
                  <button
                    type="button"
                    key={num}
                    className={num === page ? 'active' : ''}
                    onClick={() => goToPage(num)}
                  >
                    {num}
                  </button>
                ))}

                <button
                  type="button"
                  disabled={page === pageCount}
                  onClick={() => goToPage(page + 1)}
                >
                  Next
                </button>
              </div>
            )}
          </div>

          <div className="blog-body-text">
            <div className="blog-body-categories">
              <h4>Categories</h4>
              <BCategory />
            </div>
            <div className="blog-body-categories">
              <h4>Latest Posts</h4>
              <LatestPosts />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Blog
